import styled from "styled-components";

const mainContentPadding = 8;

export const ContentPadding = styled.div`
  padding-top: calc(
    ${({ theme }) => theme.baseHeaderHeight} + ${mainContentPadding}px
  );

  @media only screen and (min-width: ${({ theme }) =>
      theme.breakpoints.tablet}) {
    padding-top: calc(
      ${({ theme }) => theme.headerTablePlusHeight} + ${mainContentPadding}px
    );
  }
`;

export const BottomContentPadding = styled.div`
  padding-bottom: 120px;
`;
